import { render, staticRenderFns } from "./InputGroup.vue?vue&type=template&id=4b7b4503&scoped=true"
import script from "./InputGroup.vue?vue&type=script&lang=js"
export * from "./InputGroup.vue?vue&type=script&lang=js"
import style0 from "./InputGroup.vue?vue&type=style&index=0&id=4b7b4503&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7b4503",
  null
  
)

export default component.exports